import { DateTime } from "luxon";
import type { NewCalendarViewMode } from "../types";
import { CalendarViews } from "./calendar-views/calendar-views";
import { AppointmentListView } from "./list-view/appointment-list-view";

interface NewCalendarContentProps {
  viewMode: NewCalendarViewMode;
  currentDate: DateTime;
}

export function NewCalendarContent({ viewMode, currentDate }: NewCalendarContentProps) {
  if (viewMode === "list") {
    // List view needs different layout - it has its own scrolling behavior
    return <AppointmentListView currentDate={currentDate} />;
  }

  // All other view modes use the calendar views component with full height
  return (
    <div className="h-full">
      <CalendarViews viewMode={viewMode} currentDate={currentDate} />
    </div>
  );
}
